import React, { useState, useEffect } from 'react';
import UserSelectField from '../DebateArena/UserSelectField/UserSelectField';
import styles from './DebaterAssign.module.css';
import Button from '../ui/Button';


const DebaterAssignCache = ({
  arena,
  custom,
  roles,
  currentUser,
  cache,
  setCache,
  resetSlots,
  setSearchTarget,
  setSearchTargetTeam,
  handleUserSelect
}) => {
  const [teamSlots, setTeamSlots] = useState([]);
  const [normalizedDebaters, setNormalizedDebaters] = useState([]);
  const [teamSlotMax, setTeamSlotMax] = useState([]);
  const getTeamSlotCount = (teamIdx) => {
    const teamName = custom.teams[teamIdx];
    const count = roles?.debaters.filter(d => d?.team === teamName)?.length || 0;
    return count;
  };

  const gov = roles?.debaters.filter(d => d?.team === custom.teams[0]);
  const opp = roles?.debaters.filter(d => d?.team === custom.teams[1]);
  const biggestTeam = Math.max(gov?.length || 0, opp?.length || 0);
  const totalSlots = custom?.participants || 0;
  const teamCount = custom?.teams?.length || 0;
  const base = Math.max(biggestTeam, Math.floor(totalSlots / teamCount));

  //const teamSlotMax = custom?.teamsnumber || [];
 
useEffect(() => {
  if (!custom || !teamSlots.length) return;

  //const totalSlots = custom?.participants || 0;
  const teamAllowedSlotMax = custom?.teamsnumber || [];
  const teamCount = teamAllowedSlotMax.length;

  const totalSlotsRaw = custom?.participants || 0;
  const totalSlots = totalSlotsRaw % 2 === 0 ? totalSlotsRaw : totalSlotsRaw + 1;

  if (teamCount === 0) return;

  const k = totalSlots % teamCount;

  // Step 1: start from current teamSlots, clamp to allowed max
  let result = teamSlots.map((s, i) =>
    Math.min(s, teamAllowedSlotMax[i])
  );

  // Step 2: normalize total (shrink if needed)
  let sum = result.reduce((a, b) => a + b, 0);

  if (sum > totalSlots) {
    let overflow = sum - totalSlots;

    // reduce largest first
    const order = result
      .map((val, i) => ({ i, val }))
      .sort((a, b) => b.val - a.val);

    for (const { i } of order) {
      if (overflow <= 0) break;

      const reducible = result[i] - 1;

      if (reducible > 0) {
        const take = Math.min(reducible, overflow);
        result[i] -= take;
        overflow -= take;
      }
    }
  }

  // Step 3: grow to fill remaining slots
  let remaining = totalSlots - result.reduce((a, b) => a + b, 0);

  while (remaining > 0) {
    let progress = false;

    for (let i = 0; i < result.length; i++) {
      if (remaining === 0) break;

      if (result[i] < teamAllowedSlotMax[i]) {
        result[i]++;
        remaining--;
        progress = true;
      }
    }

    if (!progress) break;
  }

  // Step 4: enforce balance constraint
  let balanced = false;

  while (!balanced) {
    let maxVal = Math.max(...result);
    let minVal = Math.min(...result);

    if (maxVal - minVal <= k) {
      balanced = true;
      break;
    }

    // find indices
    const maxIdx = result.findIndex(v => v === maxVal);
    const minIdx = result.findIndex(v => v === minVal);

    // shift 1 slot from max → min
    if (result[maxIdx] > 1 && result[minIdx] < teamAllowedSlotMax[minIdx]) {
      result[maxIdx]--;
      result[minIdx]++;
    } else {
      break; // cannot rebalance further
    }
  }

  setTeamSlotMax(result);
}, [custom, teamSlots]);

  // Run setup only when data is ready
  useEffect(() => {
	  if (!custom || !roles?.debaters || teamCount === 0 || totalSlots === 0) return;
	  if (teamSlots.length === 0) {
      setTeamSlots(custom?.teamsnumber.map((tm, i) => { return Math.min(tm, getTeamSlotCount(i));}));
	  }

   const padded = teamSlotMax.map((slotMax, teamIdx) => {
      const teamName = custom.teams[teamIdx];
      const teamDebaters = roles.debaters.filter(d => d?.team === teamName) || [];
      return Array.from({ length: slotMax }).map((_, i) => teamDebaters[i] || null);
    }).flat();
	  
	  setNormalizedDebaters(padded);
	}, [custom, roles, teamSlotMax]);

	useEffect(() => {
		if(resetSlots == false) {
			setTeamSlots([]);
		}
	}, [resetSlots]);


	
	const handleAdjust = (teamIdx, delta) => {
		const updated = [...teamSlots];
		updated[teamIdx] = Math.min(teamSlotMax[teamIdx], updated[teamIdx] + delta);
		const sum = updated.reduce((a, b) => a + b, 0);
		if (sum <= totalSlots) {
		  setTeamSlots(updated);
		}
	};

  const maxSlotReached = () => {
		const updated = [...teamSlots];
		const sum = updated.reduce((a, b) => a + b, 0);
		if (sum < totalSlots) {
		  return false;
		}
    return true;
	};
  
  const getTeamColor = (ucolor) => {
  
	if (ucolor == "a" || ucolor == "gov" || ucolor == "team a" || ucolor == "plan" || ucolor == "pro") {
		return "pro";
	}
	else if (ucolor == "debaters") {
		return "neutral";
	}
	
	return "con";
  }

  let globalIdx = 0;

  //console.log('teamSlotMax:', teamSlots, normalizedDebaters);
  return (
    <div className={styles.debaterAssign}>
      {custom?.teams?.map((teamName, teamIdx) => {
        const slots = teamSlots[teamIdx] || 0;
        const debaters = normalizedDebaters.slice(globalIdx, globalIdx + slots);
        const filled = debaters.filter(Boolean).length;

        const elements = Array.from({ length: slots }).map((_, i) => {
          const index = globalIdx + i;
          const selected = normalizedDebaters[index];
		  
          return (
            <UserSelectField
              key={index}
              cache={cache}
              setCache={setCache}
              currentUser={currentUser}
              handleUserSelect={handleUserSelect}
              setSearchTarget={setSearchTarget}
              label={`Debater #${index + 1}`}
              selected={selected}
              isAutoSelect={false}
              onPickUser={() => {setSearchTargetTeam(teamName); setSearchTarget(index);}}
              isCurrentUser={selected?.uid === currentUser.uid}
              onSelect={(user) => {
                const updated = [...normalizedDebaters];
                updated[index] = user;
                //setNormalizedDebaters(updated);
                handleUserSelect(false, user, index, teamName, arena, normalizedDebaters);
              }}
            />
          );
        });

        globalIdx += teamSlotMax[teamIdx];

        return (
          <div key={teamName} className={`${styles.teamSection} ${styles[getTeamColor(teamName.toLowerCase())]}`}>
            <div className={styles.teamHeaderRow}>
              <h3 className={styles.teamHeader}>
                Team: {teamName.charAt(0).toUpperCase() + teamName.slice(1)} ({filled}/{slots})
              </h3>
              <div className={styles.teamControls}>
                <Button variant="ghost" onClick={() => handleAdjust(teamIdx, -1)} disabled={teamSlots[teamIdx] <= 1}>
                  -
                </Button>
                <Button
                  variant="ghost"
                  onClick={() => handleAdjust(teamIdx, 1)}
                  disabled={teamSlots[teamIdx] >= teamSlotMax[teamIdx] || maxSlotReached() == true}
                >
                  +
                </Button>
              </div>
            </div>
            <div className={styles.userFields}>{elements}</div>
          </div>
        );
      })}
    </div>
  );
};

export default DebaterAssignCache;
